/**
 * Block Component Registry
 *
 * Shared map from BlockType (kebab-case) to React component.
 * Used by report sections and data visualization modules.
 */

import type { ComponentType } from 'react';
import type { BlockProps } from './types';

import { StatCard } from './StatCard';
import { MetricGrid } from './MetricGrid';
import { BigNumber } from './BigNumber';
import { LineChart } from './LineChart';
import { AreaChart } from './AreaChart';
import { BarChart } from './BarChart';
import { StackedBarChart } from './StackedBarChart';
import { Sparkline } from './Sparkline';
import { DualAxisChart } from './DualAxisChart';
import { ScatterPlot } from './ScatterPlot';
import { PieChart } from './PieChart';
import { DonutChart } from './DonutChart';
import { Table } from './Table';
import { DataGrid } from './DataGrid';
import { ActivityFeed } from './ActivityFeed';
import { Timeline } from './Timeline';
import { Leaderboard } from './Leaderboard';
import { KeyValueList } from './KeyValueList';
import { ComparisonTable } from './ComparisonTable';
import { TreeTable } from './TreeTable';
import { Heatmap } from './Heatmap';
import { FilteredCount } from './FilteredCount';
import { ProgressRing } from './ProgressRing';
import { ProgressBar } from './ProgressBar';

 
export const BLOCK_COMPONENT_MAP: Record<string, ComponentType<BlockProps<any>>> = {
  'stat-card': StatCard,
  'metric-grid': MetricGrid,
  'big-number': BigNumber,
  'line-chart': LineChart,
  'area-chart': AreaChart,
  'bar-chart': BarChart,
  'stacked-bar-chart': StackedBarChart,
  'sparkline': Sparkline,
  'dual-axis-chart': DualAxisChart,
  'scatter-plot': ScatterPlot,
  'pie-chart': PieChart,
  'donut-chart': DonutChart,
  'table': Table,
  'data-grid': DataGrid,
  'activity-feed': ActivityFeed,
  'timeline': Timeline,
  'leaderboard': Leaderboard,
  'key-value-list': KeyValueList,
  'comparison-table': ComparisonTable,
  'tree-table': TreeTable,
  'heatmap': Heatmap,
  'filtered-count': FilteredCount,
  'progress-ring': ProgressRing,
  'progress-bar': ProgressBar,
};

/** Normalize legacy snake_case block types to canonical kebab-case */
export function normalizeBlockType(type: string): string {
  if (!type) return '';
  return type.replace(/_/g, '-');
}

/** Look up a block component by type string (handles both kebab-case and snake_case) */
 
export function getBlockComponent(type: string): ComponentType<BlockProps<any>> | undefined {
  return BLOCK_COMPONENT_MAP[normalizeBlockType(type)];
}
